"use client";

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { useAuthStore } from "@/lib/stores/authStore";
import { getUserQueryOptions } from "@/queries/user/fetchers";
import type { UserDataResponse } from "@/types/user";

/**
 * Custom hook for fetching and managing user data
 * Provides access to user profile, organization details, and workspaces
 *
 * @param userId - Optional user ID. Pass "shared-view-skip" to skip fetching (for public shared views)
 */
export function useUserData(userId?: string) {
	const { user } = useAuthStore();

	// Skip fetching if explicitly told to (used in shared view mode)
	const skipFetching = userId === "shared-view-skip";
	const effectiveUserId = skipFetching ? undefined : user?.id || userId;

	const queryOptions = getUserQueryOptions(effectiveUserId);
	const { data, error, refetch, isLoading } = useQuery<UserDataResponse>({
		...(queryOptions as UseQueryOptions<UserDataResponse>),
		// Disable query in shared view mode
		enabled: !skipFetching && queryOptions.enabled !== false,
	});

	const userData = data
		? {
				...data.user,
				orgPermissions: data.organizationPermissions,
			}
		: null;

	const organization = data ? { ...data.organization } : null;
	const workspaces = data ? [...data.workspaces] : [];

	return {
		error,
		loading: isLoading,
		organization,
		queryOptions,
		refresh: refetch,
		userData,
		workspaces,
	};
}
